import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-preview-root" }
const _hoisted_2 = {
  ref: "offcanvasElement",
  class: "offcanvas offcanvas-end content-preview-offcanvas",
  tabindex: "-1",
  id: "contentPreviewOffcanvas",
  "aria-labelledby": "contentPreviewTitle"
}
const _hoisted_3 = { class: "offcanvas-header" }
const _hoisted_4 = {
  id: "contentPreviewTitle",
  class: "offcanvas-title"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "offcanvas-body" }
const _hoisted_7 = {
  key: 0,
  class: "preview-loading"
}
const _hoisted_8 = {
  key: 1,
  class: "preview-error"
}
const _hoisted_9 = { class: "preview-meta" }
const _hoisted_10 = { class: "badge bg-secondary" }
const _hoisted_11 = {
  key: 0,
  class: "preview-books"
}
const _hoisted_12 = {
  key: 1,
  class: "preview-description"
}
const _hoisted_13 = {
  key: 2,
  class: "preview-data"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "offcanvas-footer" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString($setup.content?.name || ""), 1 /* TEXT */),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close btn-close-white",
          "data-bs-dismiss": "offcanvas",
          "aria-label": $setup.label('close', 'Close')
        }, null, 8 /* PROPS */, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa-solid fa-spinner fa-spin" }, null, -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString($setup.label("loading", "Loading...")), 1 /* TEXT */)
            ]))
          : ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa-solid fa-exclamation-triangle" }, null, -1 /* CACHED */)),
                _createTextVNode(" " + _toDisplayString($setup.errorMessage), 1 /* TEXT */)
              ]))
            : ($setup.content)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", $setup.statusClass($setup.content.status)])
                    }, _toDisplayString($setup.content.status), 3 /* TEXT, CLASS */),
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", $setup.languageClass($setup.content.language)])
                    }, _toDisplayString($setup.content.language?.toUpperCase() || "?"), 3 /* TEXT, CLASS */),
                    _createElementVNode("span", _hoisted_10, _toDisplayString($setup.content.type), 1 /* TEXT */)
                  ]),
                  ($setup.content.books?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.content.books, (book) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: book.id || book.name || book,
                            class: "badge badge-book"
                          }, _toDisplayString(book.name || book), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.content.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("h6", null, _toDisplayString($setup.label("description", "Beschreibung")), 1 /* TEXT */),
                        _createElementVNode("p", null, _toDisplayString($setup.content.description), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.content.dataEntries?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("h6", null, _toDisplayString($setup.label("data", "Daten")), 1 /* TEXT */),
                        _createElementVNode("dl", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.content.dataEntries, (entry) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: entry.key,
                              class: "preview-field"
                            }, [
                              _createElementVNode("dt", null, _toDisplayString(entry.label), 1 /* TEXT */),
                              _createElementVNode("dd", {
                                innerHTML: entry.valueHtml
                              }, null, 8 /* PROPS */, _hoisted_14)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("a", {
          href: $setup.editUrl,
          class: "btn btn-primary"
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa-solid fa-pen me-1" }, null, -1 /* CACHED */)),
          _createTextVNode(" " + _toDisplayString($setup.label("edit", "Edit")), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_16),
        _createElementVNode("a", {
          href: $setup.viewUrl,
          class: "btn btn-outline-light",
          target: "_blank"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa-solid fa-external-link me-1" }, null, -1 /* CACHED */)),
          _createTextVNode(" " + _toDisplayString($setup.label("viewFull", "View Full")), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_17)
      ])
    ], 512 /* NEED_PATCH */)
  ]))
}